export default __webpack_public_path__ + "static/media/seat2.5ef56c70.jpeg";